module.exports = __webpack_public_path__ + "static/media/icon_setting_gray.2d699aef.png";